"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable dot-notation */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
const react_1 = __importDefault(require("react"));
const SelectOption_module_scss_1 = __importDefault(require("./SelectOption.module.scss"));
function SelectOption({ id, label, value, selected, disabled = false, onClick = () => {
    /* do nothing */
}, }) {
    const clickHandler = () => {
        onClick(value);
    };
    return (react_1.default.createElement("div", { className: SelectOption_module_scss_1.default['option'], "data-disabled": disabled, "data-active": selected, key: `${label}${id}`, onClick: clickHandler }, label));
}
exports.default = SelectOption;
